/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Wallet } from "./Wallet";
import * as t from "io-ts";

// required attributes
const WalletResponseR = t.interface({});

// optional attributes
const WalletResponseO = t.partial({
  data: Wallet
});

export const WalletResponse = t.intersection(
  [WalletResponseR, WalletResponseO],
  "WalletResponse"
);

export type WalletResponse = t.TypeOf<typeof WalletResponse>;
